import { render, staticRenderFns } from "./LeadsStadistics.vue?vue&type=template&id=4e7cf4c8&scoped=true"
import script from "./LeadsStadistics.vue?vue&type=script&lang=js"
export * from "./LeadsStadistics.vue?vue&type=script&lang=js"
import style0 from "./LeadsStadistics.vue?vue&type=style&index=0&id=4e7cf4c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7cf4c8",
  null
  
)

export default component.exports